import { z } from 'zod';

export enum ReservationMembershipFormKeys {
    files = 'files',
}

export const ReservationMembershipFormSchema = z.object({
    [ReservationMembershipFormKeys.files]: z.instanceof(File).array().min(1),
});

export type ReservationMembershipFormValues = z.infer<typeof ReservationMembershipFormSchema>;
